export default __webpack_public_path__ + "static/media/browser.e12b75fe.svg";